import { useEffect, useRef } from "react";
import NoSleep from "nosleep.js";

export default function useWakeLock(videoRef) {
  const noSleepRef = useRef(new NoSleep());

  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    const enableNoSleep = () => {
      if (!noSleepRef.current.isEnabled) {
        noSleepRef.current.enable();
      }
    };

    const disableNoSleep = () => {
      if (noSleepRef.current.isEnabled) {
        noSleepRef.current.disable();
      }
    };

    videoElement.addEventListener("play", enableNoSleep);
    videoElement.addEventListener("pause", disableNoSleep);
    videoElement.addEventListener("ended", disableNoSleep);

    // Initial click/touch listener for iOS since NoSleep needs user interaction
    const handleUserInteraction = () => {
      document.removeEventListener("click", handleUserInteraction);
      document.removeEventListener("touchstart", handleUserInteraction);
    };
    
    document.addEventListener("click", handleUserInteraction);
    document.addEventListener("touchstart", handleUserInteraction);

    return () => {
      if (videoElement) {
        videoElement.removeEventListener("play", enableNoSleep);
        videoElement.removeEventListener("pause", disableNoSleep);
        videoElement.removeEventListener("ended", disableNoSleep);
      }
      document.removeEventListener("click", handleUserInteraction);
      document.removeEventListener("touchstart", handleUserInteraction);
      disableNoSleep();
    };
  }, [videoRef]);
}
